import { useTranslation } from 'react-i18next';
import { ColumnConfig } from '../../../../components/DatasetTable';
import Tag from '../../../../helpContext/Tag';
import { ConverterAisleTableRow } from '../store/converter.types';

function useConverterAislesTableConfig(): ColumnConfig<ConverterAisleTableRow>[] {
  const { t } = useTranslation('designer');
  const columnsConfig: ColumnConfig<ConverterAisleTableRow>[] = [
    {
      field: 'title',
      title: t`Aisle`,
      hasFilter: true,
    },
    {
      field: 'areaId',
      title: t`Area`,
      hasFilter: true,
    },
    {
      field: 'type',
      title: t`Type`,
      hasFilter: true,
    },
    {
      field: 'navigable',
      title: t`Navigable`,
      hasFilter: true,
    },

    {
      field: 'width',
      title: t`Width`,
      hasFilter: true,
    },
    {
      field: 'bayRowSettings.LEFT.orderType',
      title: t`Left Side Bay Order`,
      hasFilter: true,
      render: (v: string) => v ?? <Tag>{t`Unmodified`}</Tag>,
    },
    {
      field: 'bayRowSettings.RIGHT.orderType',
      title: t`Right Side Bay Order`,
      hasFilter: true,
      render: (v: string) => v ?? <Tag>{t`Unmodified`}</Tag>,
    },
    {
      field: 'locationOrderSettings.LEFT',
      title: t`Left Side Loc Order`,
      hasFilter: true,
      render: (v: string) => v ?? <Tag>{t`Unmodified`}</Tag>,
    },

    {
      field: 'locationOrderSettings.RIGHT',
      title: t`Right Side Loc Order`,
      hasFilter: true,
      render: (v: string) => v ?? <Tag>{t`Unmodified`}</Tag>,
    },
    {
      field: 'id',
      title: t`ID`,
      hasFilter: true,
    },
  ];

  return columnsConfig;
}
export default useConverterAislesTableConfig;
